import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../core/classes/user';
import { UserPreferences } from '../core/classes/user-preferences';

type EnrichUserPreferencesOptions = {
  logPrefix?: string;
};

export function enrichUserWithPreferences(
  http: HttpClient,
  user: User,
  options?: EnrichUserPreferencesOptions,
): Observable<User> {
  return http.get<UserPreferences>(`api/user/preference?userId=${user.id}`).pipe(
    catchError((error) => {
      const prefix = options?.logPrefix || 'Error fetching user preferences';
      console.error(`${prefix} for ${user.fullName}:`, error?.error?.userMessage || error?.toString?.() || error);
      return of(undefined);
    }),
    map((preferences: UserPreferences | undefined) => {
      if (preferences) {
        user.preferences = new UserPreferences(preferences);
      }
      return user;
    }),
  );
}
